import React, { useEffect, useRef } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import SuperButton from "../../elements/super-button";
import Heading from "../../elements/heading";
import "./style.scss";
import { getSitecoreComponentId } from "../../utils/siteUtils";

const HeroContentContent = props => {
  let { page } = props;
  console.log("page", page);
  let { gridType, alignment, backgroundColor, backgroundImage, backgroundAlign, overlineText, headingType, headingBody, body, bulletListItems, CTA } = props.fields;
  const componentId = getSitecoreComponentId(props);
  const rootNode = useRef(null);
  const heroContentClasses = classNames(
    "hero-content",
    {
      "grid-story": gridType && gridType.fields.phrase.value === "story"
    },
    backgroundAlign ? `bg-${backgroundAlign.fields.phrase.value}` : ""
  );
  // let getDefaultColorScheme = (model, defaultValue) => {
  //   if (!model) {return defaultValue;}
  //   return model;
  // };
  const alignClass = classNames("full-width", {
    center: (alignment && alignment.fields && alignment.fields.phrase.value) === "center",
    grid: (alignment && alignment.fields && alignment.fields.phrase.value) !== "center",
    right: (alignment && alignment.fields && alignment.fields.phrase.value) === "right"
  });

  let backgroundStyle = {};
  if (backgroundColor) {
    backgroundStyle = {
      background: backgroundColor.fields.phrase.value
    };
  }
  if (backgroundImage.value.src) {
    backgroundStyle = {
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5) ), url(" + backgroundImage.value.src + ")"
    };
  }

  useEffect(() => {
    if (global.location.hash && rootNode.current && global.location.hash.substr(1) === componentId) {
      rootNode.current.scrollIntoView(true);
    }
  }, []);
  return (
    <div className={heroContentClasses} style={backgroundStyle} id={componentId} ref={rootNode}>
      <div className={alignClass}>
        {overlineText && overlineText.value && <RichText tag="span" className="overline" field={overlineText} />}
        <Heading
          {...{
            type: headingType,
            html: headingBody
          }}
          className={"title show-on-scroll"}
        />
        {body.value && <RichText tag="div" className={"body"} field={body} />}
        {bulletListItems && bulletListItems.length !== 0 && (
          <div className={"body"}>
            <ul>
              {bulletListItems.map((item, index) => {
                return (
                  <li key={index}>
                    {item.fields.iconName && item.fields.iconName.value && item.fields.iconName.value.alt && (
                      <RichText
                        field={{
                          value: item.fields.iconName.value.alt
                        }}
                      />
                    )}
                    {item.fields.body && item.fields.body.value}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="button-container">{CTA && CTA.map((item, index) => item.fields && item.fields.ctatype && item.fields.ctatype.fields && <SuperButton key={index} {...item.fields} />)}</div>
      </div>
    </div>
  );
};
const HeroContent = props => {
  if (!props.fields) return null;
  let { gridType } = props.fields;
  if (gridType && gridType.fields.phrase.value === "story") {
    return (
      <div className={"grid"}>
        <HeroContentContent {...props} />
      </div>
    );
  }
  return <HeroContentContent {...props} />;
};

export default HeroContent;
